import {useTranslation} from 'react-i18next';

import {Grid, Typography} from '@mui/material';

import {AssignJobPostingAdminsModal} from './AssignAdminsModal/AssignJobPostingAdminsModal';
import {AboutTheJobFieldsRequirements} from './fields/AboutTheJobFieldsRequirements';
import {AboutTheJobFieldsResponsibilities} from './fields/AboutTheJobFieldsResponsibilities';
import {AboutTheJobFieldsSkills} from './fields/AboutTheJobFieldsSkills';

interface AboutTheJobFieldsProps {
  formik: any;
  modalOpen: boolean;
  onClose: () => void;
}

export const AboutTheJobFields = ({formik, modalOpen, onClose}: AboutTheJobFieldsProps) => {
  const {t} = useTranslation();

  return (
    <>
      <Typography variant='h3' gutterBottom component='div'>
        {t('companyJobPostings.newJobDialog.aboutTheJob')}
      </Typography>
      <Grid item>
        <AboutTheJobFieldsResponsibilities formik={formik} />
      </Grid>
      <Grid item>
        <AboutTheJobFieldsRequirements formik={formik} />
      </Grid>
      <Grid item>
        <AboutTheJobFieldsSkills formik={formik} />
      </Grid>
      <AssignJobPostingAdminsModal open={modalOpen} onClose={onClose} formik={formik} />
    </>
  );
};
